import {makeStyles} from '@material-ui/core/styles';
import {Divider} from "@material-ui/core";
import React from "react";
import PropTypes from "prop-types";

const useStyles = makeStyles(theme => ({
    buttonsDiv: {
        paddingTop: theme.spacing(),
        display: 'flex',
        '& > div': {
            minWidth: '50%'
        }
    },
    divider: {
        marginBottom: theme.spacing()
    },
    rightAreaDiv: {
        display: 'flex',
        justifyContent: 'flex-end',
        gap: theme.spacing(1)
    }
}));

export default function ButtonArea(props) {
    const {
        leftArea,
        rightArea
    } = props;
    const classes = useStyles();

    return (
        <>
            <Divider className={classes.divider} />
            <div className={classes.buttonsDiv}>
                <div className={classes.leftAreaDiv}>
                    {leftArea}
                </div>
                <div className={classes.rightAreaDiv}>
                    {rightArea}
                </div>
            </div>
        </>
    );
};

ButtonArea.propTypes = {
    leftArea: PropTypes.element,
    rightArea: PropTypes.element
};